import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import CustomFieldsSetCustomFieldUpdateActionGeneric from "@commercetools-local/topics/custom-fields/set-custom-field-update-action-generic.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`This action sets, overwrites, or removes any existing `}<a parentName="p" {...{
          "href": "/api/../api/projects/custom-fields#custom"
        }}>{`custom`}</a>{` field for an existing order.`}</p>
      <CustomFieldsSetCustomFieldUpdateActionGeneric mdxType="CustomFieldsSetCustomFieldUpdateActionGeneric" />

    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      